module.exports = __webpack_public_path__ + "static/img/lacobel-matelac-2.41c8710.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/agc/items/lacobel-matelac/lacobel-matelac-2.jpg
// module id = 520
// module chunks = 0